import Markdown from '@components/v2/ui/Markdown/Markdown';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import { AnnouncementContent } from '../../services/modules/announcements/announcements.types';
import { formatDate } from '../../utils/dates';
import { AnnouncementBarTestIds } from '../../utils/testIds/Announcements.testIds';

interface AnnouncementDetailsProps {
  publishedAt: string;
  content: AnnouncementContent;
}

const MEDIA_STYLES = {
  width: '100%',
  aspectRatio: '16 / 9',
  objectFit: 'cover',
  borderRadius: 4,
  marginTop: 2,
} as const;

const AnnouncementDetails = ({ publishedAt, content }: AnnouncementDetailsProps) => {
  return (
    <Box test-id={AnnouncementBarTestIds.DETAILS}>
      <Typography
        variant="caption"
        color="textSecondary"
        component="p"
        testId={AnnouncementBarTestIds.DETAILS_PUBLISHED_AT}
      >
        {formatDate(publishedAt, 'PPP')}
      </Typography>

      {content.media?.type === 'video' && (
        <Box
          component="video"
          controls
          src={content.media.url}
          test-id={AnnouncementBarTestIds.DETAILS_VIDEO}
          sx={MEDIA_STYLES}
        />
      )}

      {content.media?.type === 'image' && (
        <Box
          component="img"
          src={content.media.url}
          alt={content.title}
          test-id={AnnouncementBarTestIds.DETAILS_IMAGE}
          sx={MEDIA_STYLES}
        />
      )}

      <Typography
        variant="h6"
        testId={AnnouncementBarTestIds.DETAILS_TITLE}
        sx={{ marginTop: 2, fontWeight: 'bold' }}
      >
        {content.title}
      </Typography>

      <Markdown sx={{ marginTop: 1 }}>{content.text}</Markdown>
    </Box>
  );
};

export default AnnouncementDetails;
